export const PREV = `Назад`;
export const NEXT = `Вперед`;
